import React from "react";
import { useEffect } from "react";
export default function GLIFOSredirect(props){
    useEffect(()=>{
        window.location.assign(window.location.pathname);
    });
    return <div></div>;
}